import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { LDFlagValue } from 'launchdarkly-js-client-sdk';

import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { AWSFirehoseService } from '../../../lazy-modules/awsFirehose/service/aws-firehose.service';
import { DEFAULT_FLAG_VARIATIONS, FEATURE_FLAGS, NO_FEATURE_STATE } from '../../../lazy-modules/flagSource/constants/flag-source.constants';
import { FlagUtils } from '../../../lazy-modules/flagSource/models/flag.utils';

@Component({
    imports: [CommonModule],
    selector: 'ld-flag1',
    template: ``,
})
export class LdFlag1Component implements OnInit {
    private title: string = 'flagDummy1';
    private flagDummy1Variant: boolean = false;
    constructor(
        private pubsub: PubSubService,
        private awsService: AWSFirehoseService,
    ) {}
    ngOnInit(): void {
        this.flagDummy1Variant = this.getFlagVariant();
        (window as { [key: string]: any })['ldClient'] &&
            this.awsService.addAction('Launch Darkly Dummy Flag1 evaluation on init, flagName =>', {
                flag: FEATURE_FLAGS.DummyFlag1,
                variant: this.flagDummy1Variant,
            });
        // To evaluate Flag at LD initialization
        this.pubsub.subscribe(this.title, [this.pubsub.API.FLAG_LD_INIT], () => {
            this.flagDummy1Variant = FlagUtils.getFlagVariation(FEATURE_FLAGS.DummyFlag1, DEFAULT_FLAG_VARIATIONS.DummyFlag1) || NO_FEATURE_STATE;
            this.awsService.addAction('Launch Darkly Dummy Flag1 evaluation, flagName =>', {
                flag: FEATURE_FLAGS.DummyFlag1,
                variant: this.flagDummy1Variant,
            });
        });
        // This is to get the flag change update
        this.pubsub.subscribe(this.title, `FLAG_UPDATE_${FEATURE_FLAGS.DummyFlag1}`, (flagValue: boolean) => {
            this.flagDummy1Variant = flagValue;
            this.awsService.addAction('Launch Darkly Dummy Flag1 evaluation, flagName =>', {
                flag: FEATURE_FLAGS.DummyFlag1,
                variant: this.flagDummy1Variant,
            });
        });
    }
    /**
     * To get the latest flag variant and update the UI
     * @returns Flag updated value
     */
    private getFlagVariant(): LDFlagValue {
        return FlagUtils.getFlagVariation(FEATURE_FLAGS.DummyFlag1, DEFAULT_FLAG_VARIATIONS.DummyFlag1) || NO_FEATURE_STATE;
    }
}
